import cls from 'classnames';

import { Tooltip } from '../Tooltip';

import { IWithTooltipProps } from './types';
import useStyles from './styles';

const positionMap = {
  up: 'down',
  down: 'up',
} as const;

export default function WithTooltip({
  children,
  color = 'black',
  className,
  position = 'down',
  text,
}: IWithTooltipProps) {
  const tooltipPosition = positionMap[position];
  const classes = useStyles({ position: tooltipPosition });

  return (
    <div className={cls(classes.root, className)}>
      {children}
      <Tooltip
        className={cls('with-tooltip-inner', classes.tooltip)}
        withArrow
        arrowType={tooltipPosition}
        color={color}
      >
        {text}
      </Tooltip>
    </div>
  );
}
